export default "__VITE_ASSET__XvAkWkOL__"